<template>
    <div v-if="!loading && !loadx">
        <!-- <div>
            <router-link :to="'/purchase?upgrade='+set_business.business_username" class="btn  sp-button-02 sp-button-sm" style="background-color: #ff3c00;">Upgrade Shop</router-link>
        </div> -->
        <div v-if="(Object.keys(category).length == 0)">
            <h3>Select Category</h3>
            <div class="card" v-for="(set_category,index) in product_categories" :key="index">
                <p><a class="btn sp-button-02-lt" @click="category = set_category">{{ set_category.category_name }}</a></p>
                <hr/>
            </div>
        </div>
        <div v-else>
            <div class="form-card">
                <!-- <h3>Add new product</h3> -->
                <h4><u>Add product to {{category.category_name}}</u></h4>
                <div>
                    <div class="category-slide" id="imset1">
                        <ul>
                            <li v-for="(f,fdex) in files_info" :key="fdex">
                                <div style="width: 100px; height: 100px;">
                                    <img :id="'prImagePreviewXD'+fdex" style="width:100%;height: 100%;"/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <button v-if="files_info.length > 0" class="btn sp-button-02-lt" @click="files_info = []">Reset Images</button>
                            
                    <form class="sp-form">
                        <!-- <h6>Add New <span style="text-transform: capitalize">{{is_product_service}}</span></h6> -->
                        <div class="form-group">
                            <label>Product Photos </label>
                            <img id="prImagePreview" style="width:100%"/>
                            <div class="sp-form-descr">Maximum Upload Size {{max_upload}}</div>
                            <div class="upload-btn-wrapper" style="cursor:pointer">
                                <button type="button" class="upload-btn">Upload Display <span style="text-transform: capitalize;">{{is_product_service}}</span> Photo</button>
                                <input type="file" id="input-file" @change="onFileChangeMultiplePrep($event)"  multiple accept="image/*"/>
                                <!-- <input type="file" id="input-file" @change="onFileChangeNewProduct($event)" accept="image/*"/> -->
                                <!-- <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                        -->
                            </div>
                        </div>
                        <div class=""> 
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" v-model="product.product_name" class="form-control" placeholder="Name of Product / Service"/></td>
                            </div>
                            <div class="form-group">
                                <label>Price</label>
                                <input type="number" v-model="product.product_item_price" class="form-control" placeholder=""  required @change="numStrip()">
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <textarea style="height:300px" v-model="product.product_description" class="form-control" placeholder="Details"></textarea>
                            </div>

                            <!--add--to-more-categories-->
                            <div class="">
                                <h4>Add to more categories</h4>
                                <div v-for="cat in product_categories" :key="cat.catgory_id" v-if="cat.category_id != category.category_id">
                                    <p><input type="checkbox" class="" @click="setAddProductToMultipleCategories(cat)"/>&nbsp;&nbsp;{{ cat.category_name }}</p>
                                </div>
                            </div>
                            <!--add--to-more-categories-->
                        
                            <div class="form-group">
                                <p style="color:#1a73da">{{data_processing_message}}<br><br/>
                                <span style="color:#ff0000">{{data_error_message}}</span></p>
                                <div v-if="action_loading" class="loading-sm"></div>
                                <button :disabled="disable_btn" type="button" class="btn sp-button-02 sp-button-sm"  @click="addProduct">ADD <span style="text-transform: uppercase">{{is_product_service}}</span></button>
                                <!-- <button type="button" class="btn sp-button-02 sp-button-sm" @click="reset">Cancel</button> -->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import AccountResources from '../../Template/script.js' //scripts
//import AccountResources from '../../Resources/script.js' //scripts
import commonfunctions from "../../Resources/commonfunctions";
import Purchase from '../../../Purchase'
export default {
    mixins: [commonfunctions],
    data () {
        return {
            loadx: true,
            set_user:this.$store.getters['account/getUser'],
            set_business:this.$store.getters['account/getUserBusiness'],
            set_sub_offers:this.$store.getters['account/getSellpointAppSubscriptionOffers'],
        }
    },

    methods: {
        setPage(){
            let self = this;
            localforage.getItem('set_product_category', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.category = value;
                }else{}
                self.loadx = false;
            });
        },
       
    },

    components: {
        'purchase':Purchase,
    },

    created: function(){
        this.loading = true;
        this.setPage();
        //this.loadCategory();
        this.getProductCategories();
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// AddProduct.vue?a51eafc2